import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { useCart } from '../context/CartContext';
import Loader from '../components/Loader';

const HomePage = () => {
  const [currentHero, setCurrentHero] = useState(0);
  const { addToCart, isInCart, getItemQuantity } = useCart();
  const [loading, setLoading] = useState(true);

  // Featured dishes for homepage
  const featuredDishes = [
    {
      id: 1,
      name: 'Jollof Rice',
      description: 'Authentic Nigerian party jollof rice with tender chicken pieces',
      price: 3700,
      image: '/images/categories/Rice Boxes/jollof-rice.jpg',
      rating: 4.9,
      popular: true
    },
    {
      id: 7,
      name: 'Asun',
      description: 'Spicy grilled goat meat skewers with peppers and onions',
      price: 2500,
      image: '/images/chef/Asun.jpeg',
      rating: 4.1,
      popular: true
    },
    {
      id: 29,
      name: 'Meat Pie',
      description: 'Delicious meat pie filled with spiced minced meat',
      price: 2500,
      image: '/images/categories/pastries/meat-pie.jpg',
      rating: 4.9,
      popular: true
    }
  ];

  const heroSlides = [
    {
      id: 1,
      title: "Authentic Nigerian Cuisine 🇳🇬",
      subtitle: "Delivered Fresh to Your Door in 30 Minutes!",
      image: "/images/categories/Rice Boxes/jollof-rice.jpg",
      cta: "Order Jollof Rice Now",
      color: "#008751"
    },
    {
      id: 2,
      title: "Traditional Flavors 🍲",
      subtitle: "Experience the Rich Heritage of Nigerian Food",
      image: "/images/categories/soup/Egusi.jpeg",
      cta: "Browse Traditional Menu",
      color: "#fb923c"
    },
    {
      id: 3,
      title: "Fresh & Delicious 🔥",
      subtitle: "Made with Love, Served with Pride",
      image: "/images/chef/Asun.jpeg",
      cta: "See All Dishes",
      color: "#dc2626"
    }
  ];

  // Auto-rotate hero slides
  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentHero((prev) => (prev + 1) % heroSlides.length);
    }, 5000);
    return () => clearInterval(interval);
  }, [heroSlides.length]);

  // Simulate loading time
  useEffect(() => {
    const timer = setTimeout(() => {
      setLoading(false);
    }, 1000);
    return () => clearTimeout(timer);
  }, []);

  // --- Loader integration here ---
  if (loading) {
    return <Loader text="Loading menu..." />;
  }

  return (
    <div className="main-container" style={{
      background: 'linear-gradient(135deg, #FFF8DC, #f8f9fa)',
      minHeight: '100vh'
    }}>
      {/* HERO SECTION with Carousel */}
      <section style={{
        height: '80vh',
        position: 'relative',
        overflow: 'hidden',
        display: 'flex',
        alignItems: 'center'
      }}>
        {heroSlides.map((slide, index) => (
          <div
            key={slide.id}
            style={{
              position: 'absolute',
              top: 0,
              left: 0,
              width: '100%',
              height: '100%',
              background: `linear-gradient(135deg, ${slide.color}, #fb923c)`,
              display: 'flex',
              alignItems: 'center',
              opacity: index === currentHero ? 1 : 0,
              transition: 'opacity 1s ease-in-out',
              padding: '0 2rem'
            }}
          >
            <div style={{
              maxWidth: '1200px',
              margin: '0 auto',
              display: 'grid',
              gridTemplateColumns: '1fr 1fr',
              gap: '4rem',
              alignItems: 'center',
              width: '100%'
            }}>
              {/* Text Content */}
              <div style={{ color: 'white' }}>
                <h1 style={{
                  fontSize: '4rem',
                  fontWeight: '900',
                  marginBottom: '2rem',
                  lineHeight: '1.1',
                  textShadow: '3px 3px 6px rgba(0,0,0,0.4)',
                  animation: 'slideInLeft 1s ease-out'
                }}>
                  {slide.title}
                </h1>
                <p style={{
                  fontSize: '1.5rem',
                  marginBottom: '3rem',
                  opacity: 0.95,
                  animation: 'slideInLeft 1s ease-out 0.2s both'
                }}>
                  {slide.subtitle}
                </p>
                <div style={{
                  display: 'flex',
                  gap: '1.5rem',
                  animation: 'slideInLeft 1s ease-out 0.4s both'
                }}>
                  <Link
                    to="/menu"
                    style={{
                      background: 'rgba(255,255,255,0.2)',
                      color: 'white',
                      padding: '1.5rem 3rem',
                      borderRadius: '30px',
                      textDecoration: 'none',
                      fontWeight: '800',
                      fontSize: '1.2rem',
                      border: '2px solid rgba(255,255,255,0.3)',
                      backdropFilter: 'blur(10px)',
                      transition: 'all 0.3s ease'
                    }}
                    onMouseOver={(e) => {
                      e.target.style.background = 'rgba(255,255,255,0.3)';
                      e.target.style.transform = 'translateY(-3px)';
                    }}
                    onMouseOut={(e) => {
                      e.target.style.background = 'rgba(255,255,255,0.2)';
                      e.target.style.transform = 'translateY(0)';
                    }}
                  >
                    🍽️ {slide.cta}
                  </Link>
                </div>
              </div>

              {/* Food Image */}
              <div style={{
                display: 'flex',
                justifyContent: 'center',
                animation: 'slideInRight 1s ease-out 0.3s both'
              }}>
                <div style={{
                  width: '400px',
                  height: '400px',
                  borderRadius: '50%',
                  overflow: 'hidden',
                  border: '8px solid rgba(255,255,255,0.3)',
                  boxShadow: '0 20px 60px rgba(0,0,0,0.3)',
                  animation: 'float 3s ease-in-out infinite'
                }}>
                  <img
                    src={slide.image}
                    alt={slide.title}
                    style={{
                      width: '100%',
                      height: '100%',
                      objectFit: 'cover'
                    }}
                  />
                </div>
              </div>
            </div>
          </div>
        ))}

        {/* Hero Navigation Dots */}
        <div style={{
          position: 'absolute',
          bottom: '2rem',
          left: '50%',
          transform: 'translateX(-50%)',
          display: 'flex',
          gap: '1rem'
        }}>
          {heroSlides.map((_, index) => (
            <button
              key={index}
              onClick={() => setCurrentHero(index)}
              style={{
                width: '15px',
                height: '15px',
                borderRadius: '50%',
                border: 'none',
                background: index === currentHero
                  ? 'rgba(255,255,255,0.9)'
                  : 'rgba(255,255,255,0.4)',
                cursor: 'pointer',
                transition: 'all 0.3s ease'
              }}
            />
          ))}
        </div>
      </section>

      {/* FEATURED DISHES SECTION */}
      <section style={{
        padding: '5rem 2rem',
        maxWidth: '1400px',
        margin: '0 auto'
      }}>
        <div style={{ textAlign: 'center', marginBottom: '4rem' }}>
          <h2 style={{
            fontSize: '3rem',
            fontWeight: '900',
            color: '#008751',
            marginBottom: '1rem'
          }}>
            🔥 Featured Dishes
          </h2>
          <p style={{
            fontSize: '1.2rem',
            color: '#6b7280',
            maxWidth: '600px',
            margin: '0 auto'
          }}>
            Try our most popular Nigerian dishes, loved by thousands of customers
          </p>
        </div>

        <div className="featured-dishes-grid" style={{
          display: 'grid',
          gridTemplateColumns: 'repeat(auto-fit, minmax(350px, 1fr))',
          gap: '2rem'
        }}>
          {featuredDishes.map(dish => (
            <div key={dish.id} style={{
              background: 'white',
              borderRadius: '25px',
              padding: '2rem',
              boxShadow: '0 12px 30px rgba(0,0,0,0.1)',
              border: '2px solid #f8f9fa',
              transition: 'all 0.4s ease',
              position: 'relative'
            }}>
              {/* Popular Badge */}
              {dish.popular && (
                <div style={{
                  position: 'absolute',
                  top: '1rem',
                  right: '1rem',
                  background: 'linear-gradient(135deg, #ff6b6b, #ff4757)',
                  color: 'white',
                  padding: '0.5rem 1rem',
                  borderRadius: '20px',
                  fontSize: '0.8rem',
                  fontWeight: '800',
                  animation: 'pulse 2s infinite'
                }}>
                  🔥 Popular
                </div>
              )}

              {/* Dish Image */}
              <div style={{
                width: '100%',
                height: '250px',
                borderRadius: '20px',
                overflow: 'hidden',
                marginBottom: '1.5rem',
                boxShadow: '0 8px 25px rgba(0,0,0,0.1)'
              }}>
                <img
                  src={dish.image}
                  alt={dish.name}
                  style={{
                    width: '100%',
                    height: '100%',
                    objectFit: 'cover',
                    transition: 'transform 0.4s ease'
                  }}
                  onMouseOver={(e) => {
                    e.target.style.transform = 'scale(1.1)';
                  }}
                  onMouseOut={(e) => {
                    e.target.style.transform = 'scale(1)';
                  }}
                />
              </div>

              {/* Dish Details */}
              <h3 style={{
                fontSize: '1.5rem',
                fontWeight: '900',
                color: '#008751',
                marginBottom: '0.8rem',
                textAlign: 'center'
              }}>
                {dish.name}
              </h3>

              <p style={{
                color: '#6b7280',
                lineHeight: '1.6',
                marginBottom: '1.5rem',
                textAlign: 'center'
              }}>
                {dish.description}
              </p>

              {/* Price and Rating */}
              <div style={{
                display: 'flex',
                justifyContent: 'space-between',
                alignItems: 'center',
                marginBottom: '1.5rem'
              }}>
                <span style={{
                  fontSize: '1.6rem',
                  fontWeight: '900',
                  color: '#fb923c'
                }}>
                  ₦{dish.price.toLocaleString()}
                </span>
                <span style={{
                  color: '#6b7280',
                  fontSize: '1rem'
                }}>
                  ⭐ {dish.rating}
                </span>
              </div>

              {/* Cart Status */}
              {isInCart(dish.id) && (
                <div style={{
                  background: '#22c55e',
                  color: 'white',
                  padding: '0.5rem 1rem',
                  borderRadius: '15px',
                  textAlign: 'center',
                  fontSize: '0.9rem',
                  fontWeight: '700',
                  marginBottom: '1rem'
                }}>
                  {getItemQuantity(dish.id)} in cart ✓
                </div>
              )}

              {/* Add to Cart Button */}
              <button
                onClick={() => addToCart(dish)}
                style={{
                  width: '100%',
                  background: 'linear-gradient(135deg, #008751, #fb923c)',
                  color: 'white',
                  border: 'none',
                  padding: '1.2rem',
                  borderRadius: '18px',
                  fontWeight: '900',
                  fontSize: '1.1rem',
                  cursor: 'pointer',
                  transition: 'all 0.3s ease'
                }}
                onMouseOver={(e) => {
                  e.target.style.transform = 'translateY(-3px)';
                  e.target.style.boxShadow = '0 10px 30px rgba(0, 135, 81, 0.4)';
                }}
                onMouseOut={(e) => {
                  e.target.style.transform = 'translateY(0)';
                  e.target.style.boxShadow = 'none';
                }}
              >
                🛒 Add to Cart
              </button>
            </div>
          ))}
        </div>

        {/* View All Menu Button */}
        <div style={{ textAlign: 'center', marginTop: '3rem' }}>
          <Link
            to="/menu"
            style={{
              background: 'linear-gradient(135deg, #008751, #fb923c)',
              color: 'white',
              padding: '1.5rem 4rem',
              borderRadius: '30px',
              textDecoration: 'none',
              fontWeight: '800',
              fontSize: '1.3rem',
              display: 'inline-block',
              transition: 'all 0.3s ease',
              boxShadow: '0 8px 25px rgba(0,0,0,0.15)'
            }}
            onMouseOver={(e) => {
              e.target.style.transform = 'translateY(-5px)';
              e.target.style.boxShadow = '0 15px 40px rgba(0,0,0,0.2)';
            }}
            onMouseOut={(e) => {
              e.target.style.transform = 'translateY(0)';
              e.target.style.boxShadow = '0 8px 25px rgba(0,0,0,0.15)';
            }}
          >
            🍽️ View Full Menu (43 Dishes)
          </Link>
        </div>
      </section>

      {/* WHY CHOOSE US SECTION */}
      <section style={{
        background: 'white',
        padding: '5rem 2rem',
        margin: '3rem 2rem',
        borderRadius: '30px',
        boxShadow: '0 12px 30px rgba(0,0,0,0.1)'
      }}>
        <div style={{
          maxWidth: '1200px',
          margin: '0 auto',
          textAlign: 'center'
        }}>
          <h2 style={{
            fontSize: '3rem',
            fontWeight: '900',
            color: '#008751',
            marginBottom: '3rem'
          }}>
            🇳🇬 Why Choose TiwaTinwa?
          </h2>

          <div style={{
            display: 'grid',
            gridTemplateColumns: 'repeat(auto-fit, minmax(250px, 1fr))',
            gap: '3rem'
          }}>
            {[
              {
                icon: '⚡',
                title: 'Lightning Fast',
                description: 'Fresh food delivered in 30-45 minutes guaranteed'
              },
              {
                icon: '🇳🇬',
                title: 'Authentic Nigerian',
                description: 'Traditional recipes passed down through generations'
              },
              {
                icon: '🔥',
                title: 'Always Fresh',
                description: 'Cooked to order with the finest local ingredients'
              },
              {
                icon: '💯',
                title: '100% Satisfaction',
                description: 'Money back guarantee if you\'re not completely happy'
              }
            ].map((feature, index) => (
              <div key={index} style={{
                padding: '2rem',
                borderRadius: '20px',
                transition: 'transform 0.3s ease'
              }}
              onMouseOver={(e) => {
                e.target.style.transform = 'translateY(-10px)';
              }}
              onMouseOut={(e) => {
                e.target.style.transform = 'translateY(0)';
              }}
              >
                <div style={{
                  fontSize: '4rem',
                  marginBottom: '1rem'
                }}>
                  {feature.icon}
                </div>
                <h3 style={{
                  fontSize: '1.5rem',
                  fontWeight: '800',
                  color: '#008751',
                  marginBottom: '1rem'
                }}>
                  {feature.title}
                </h3>
                <p style={{
                  color: '#6b7280',
                  lineHeight: '1.6'
                }}>
                  {feature.description}
                </p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* CALL TO ACTION SECTION */}
      <section style={{
        background: 'linear-gradient(135deg, #008751, #fb923c)',
        color: 'white',
        padding: '5rem 2rem',
        textAlign: 'center'
      }}>
        <div style={{
          maxWidth: '800px',
          margin: '0 auto'
        }}>
          <h2 style={{
            fontSize: '3rem',
            fontWeight: '900',
            marginBottom: '2rem',
            textShadow: '3px 3px 6px rgba(0,0,0,0.4)'
          }}>
            Ready to Experience Real Nigerian Flavors? 🍽️
          </h2>
          <p style={{
            fontSize: '1.3rem',
            marginBottom: '3rem',
            opacity: 0.95
          }}>
            Join thousands of satisfied customers who trust TiwaTinwa for authentic Nigerian cuisine
          </p>
          <div style={{
            display: 'flex',
            gap: '2rem',
            justifyContent: 'center',
            flexWrap: 'wrap'
          }}>
            <Link
              to="/menu"
              style={{
                background: 'rgba(255,255,255,0.2)',
                color: 'white',
                padding: '1.5rem 3rem',
                borderRadius: '30px',
                textDecoration: 'none',
                fontWeight: '800',
                fontSize: '1.2rem',
                border: '2px solid rgba(255,255,255,0.3)',
                backdropFilter: 'blur(10px)',
                transition: 'all 0.3s ease'
              }}
              onMouseOver={(e) => {
                e.target.style.background = 'rgba(255,255,255,0.3)';
                e.target.style.transform = 'translateY(-3px)';
              }}
              onMouseOut={(e) => {
                e.target.style.background = 'rgba(255,255,255,0.2)';
                e.target.style.transform = 'translateY(0)';
              }}
            >
              🛒 Order Now
            </Link>
            <Link
              to="/contact"
              style={{
                background: 'transparent',
                color: 'white',
                padding: '1.5rem 3rem',
                borderRadius: '30px',
                textDecoration: 'none',
                fontWeight: '800',
                fontSize: '1.2rem',
                border: '2px solid rgba(255,255,255,0.5)',
                transition: 'all 0.3s ease'
              }}
              onMouseOver={(e) => {
                e.target.style.background = 'rgba(255,255,255,0.1)';
                e.target.style.transform = 'translateY(-3px)';
              }}
              onMouseOut={(e) => {
                e.target.style.background = 'transparent';
                e.target.style.transform = 'translateY(0)';
              }}
            >
              📞 Contact Us
            </Link>
          </div>
        </div>
      </section>

      {/* ANIMATIONS & RESPONSIVE STYLES */}
      <style>{`
        body { overflow-x: hidden; }
        .main-container, .checkout-container {
          box-sizing: border-box;
          width: 100%;
          max-width: 100vw;
          overflow-x: hidden;
        }
        section, .section {
          box-sizing: border-box;
          width: 100%;
          max-width: 100vw;
        }
        @keyframes slideInLeft {
          from { transform: translateX(-100px); opacity: 0; }
          to { transform: translateX(0); opacity: 1; }
        }
        @keyframes slideInRight {
          from { transform: translateX(100px); opacity: 0; }
          to { transform: translateX(0); opacity: 1; }
        }
        @keyframes float {
          0%, 100% { transform: translateY(0px); }
          50% { transform: translateY(-20px); }
        }
        @keyframes pulse {
          0%, 100% { transform: scale(1); }
          50% { transform: scale(1.05); }
        }
        @media (max-width: 1024px) {
          .main-container, .checkout-container {
            max-width: 98vw !important;
            padding: 1.5rem !important;
          }
          h1 { font-size: 2.2rem !important; }
          h2 { font-size: 1.5rem !important; }
        }
        @media (max-width: 768px) {
          .main-container, .checkout-container {
            max-width: 100vw !important;
            padding: 1rem !important;
            border-radius: 0 !important;
            box-shadow: none !important;
          }
          section, .section {
            padding: 2rem 0.5rem !important;
            margin: 1rem 0 !important;
          }
          h1 { font-size: 1.5rem !important; }
          h2 { font-size: 1.2rem !important; }
          .featured-dishes-grid {
            grid-template-columns: 1fr !important;
            gap: 1rem !important;
          }
        }
        @media (max-width: 480px) {
          .main-container, .checkout-container {
            padding: 0.5rem !important;
          }
          h1, h2 { font-size: 1.1rem !important; }
        }
      `}</style>
    </div>
  );
};
export default HomePage;